import React, { useCallback } from 'react';
import { useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import SometingWrongIcon from '../../../assets/something-wrong-icon.svg';
import Mixpanel from '../../../helpers/mixpanel';
import { Button } from '../components';

import styles from '../../styles/views/pages/ErrorBoundary.module.scss';

const ErrorBoundary = () => {
  const error = useRouteError();

  Sentry.captureException(error, error.stack);
  Mixpanel.track('Server error page shown', { errorMessage: error.message, errorInfo: error.stack });

  const refreshPage = useCallback(() => window.location.reload(true), []);

  return (
    <div className={styles.container}>
      <div className={styles.contentBlock}>
        <SometingWrongIcon />
        <p className={styles.noProjectInfo}>It looks like something has gone wrong</p>
        <span className={styles.getInTouch}>
          Our engineering team will be looking into it. Please try refreshing the page, and if that doesn’t work, please check back shortly.
        </span>
        <div className={styles.buttonsWrapper}>
          {/* TODO: Use this functionality after the bug will be fixed https://storyterrace.atlassian.net/browse/ST-3014  */}
          {/* <Button
            value="Report issue"
            variant="primary"
            color="red"
            onClick={() => {
              Sentry.showReportDialog({
                eventId: this.state.eventId,
                user: { name: `${user.firstName} ${user.lastName}`, email: user.email },
              });
            }
          }
            name="reportIssue"
            extraStyles={{ marginRight: '16px' }}
          /> */}
          <Button
            value="refresh"
            variant="secondary"
            color="red"
            onClick={refreshPage}
            name="refresh"
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
